import * as React from "react";
const SvgNavigateDownLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.707 8.293 12 14.585l6.293-6.292a1 1 0 1 1 1.414 1.414l-7 7a1 1 0 0 1-.53.277l-.118.014h-.118a1 1 0 0 1-.648-.29l-7-7a1 1 0 1 1 1.414-1.415", clipRule: "evenodd" }));
export default SvgNavigateDownLine;
